// ─── src/api/fnfSurvey.ts ────────────────────────────────────────────────────
//
// Admin-side API for the FNF "Entrepreneurship in Syria 2026" survey.

import { apiClient } from "./registration";

const BASE = "/fnf-survey";

export interface FnfSurveyResponse {
  id: string;

  consentResearch: boolean;
  consentAge18Plus: boolean;
  projectRole: string;
  syriaRelation: string;

  residesInSyria: boolean;
  residenceCountry?: string | null;
  projectGovernorate: string;
  age: number;
  gender: string;
  isWorkingOnProject: boolean;
  projectDuration: string;
  projectStage: string;
  projectType: string;
  projectSector: string;
  projectDescription: string;
  womenOwnership: string;
  legalStatus: string;
  registrationMonthYear?: string | null;
  salesChange: string;

  receivedFunding: boolean;
  fundingTypes: string[];
  fundingSources: string[];
  fundingObstacles: string[];

  startupDifficulty: string;
  challengeGrid: Record<string, string>;
  topChallenges: string[];
  neededServices: string[];

  targetCustomers: string[];
  customerLocations: string[];
  acquisitionChannels: string[];
  acquisitionObstacles: string[];

  recoveryImportance: number;
  recoveryDomains: string[];
  recoveryActivityStatus: string;
  mainContribution: string[];

  businessExperience: number;
  hardestSkills: string[];
  digitalTools: string[];
  conditionsCurrentGrid: Record<string, string>;
  conditionsYoyGrid: Record<string, string>;

  supportReceived: string[];
  programResults: string[];
  neededSupport: string[];

  awareGovProgram: string;
  neededGovServices: string[];
  topReforms: string[];
  openComment?: string | null;

  consentInterview: boolean;
  consentCaseStudy: boolean;
  contactInfo?: string | null;

  createdAt: string;
}


export interface FnfSurveyStats {
  total: number;
  averageRecoveryImportance: number;
  averageBusinessExperience: number;
  averageAge: number;
  consentedToInterview: number;
  consentedToCaseStudy: number;
  byGovernorate: Record<string, number>;
  bySector: Record<string, number>;
  byStage: Record<string, number>;
  byGender: Record<string, number>;
  byLegalStatus: Record<string, number>;
  byTopChallenges: Record<string, number>;
  byNeededSupport: Record<string, number>;
  byTopReforms: Record<string, number>;
}

export interface FnfSurveyListParams {
  page?: number;
  limit?: number;
  search?: string;
  governorate?: string;
}

export interface FnfSurveyList {
  data: FnfSurveyResponse[];
  total: number;
  page: number;
  limit: number;
}

export const getFnfSurveyResponses = async (
  params: FnfSurveyListParams,
): Promise<FnfSurveyList> => {
  const { data } = await apiClient.get<FnfSurveyList>(BASE, { params });
  return data;
};

export const getFnfSurveyStats = async (): Promise<FnfSurveyStats> => {
  const { data } = await apiClient.get<FnfSurveyStats>(`${BASE}/stats`);
  return data;
};

export const getFnfSurveyResponse = async (
  id: string,
): Promise<FnfSurveyResponse> => {
  const { data } = await apiClient.get<FnfSurveyResponse>(`${BASE}/${id}`);
  return data;
};

export const deleteFnfSurveyResponse = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
